import { render, staticRenderFns } from "./Scoreboard.vue?vue&type=template&id=5bea0051&lang=pug&"
import script from "./Scoreboard.vue?vue&type=script&lang=js&"
export * from "./Scoreboard.vue?vue&type=script&lang=js&"
import style0 from "./Scoreboard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports